module.exports = __webpack_public_path__ + "img/traplift-header-desktop.abee0228.jpg";